export const updateNestedObjectValue = <
  T extends Record<string, any>,
  Updater extends Record<string, any>,
>(
  data: T | Updater,
  path: string[],
  updater: (currentValue: Updater) => any,
): T => {
  const [key, ...rest] = path;

  if (!key) {
    const result = updater(data as Updater);

    return result as T;
  }

  return {
    ...data,
    [key]: updateNestedObjectValue(
      data[key as keyof typeof data] as T,
      rest,
      updater,
    ),
  } as T;
};
